export const paginationDefaults = { page: 1, page_size: 50 };
